export const beurl = process.env.VUE_APP_BEURL;

export const resAnnoMap = { 0: '正确', 1: '错误', 2: '申诉中', 3: '申诉完成-正确', 4: '申诉完成-错误' };
export const roleMap = {
  0: 'default',
  1: 'admin',
  2: 'customer',
  3: 'annotator',
  4: 'approver',
  5: 'approverTwo',
  6: 'reviewer',
};
export const roleMapReverse = { admin: 1, customer: 2, annotator: 3, approver: 4, approverTwo: 5, reviewer: 6 };
export const roleMapChinese = {
  0: '练习生',
  1: '管理员',
  2: '客户',
  3: '标注员',
  4: '审核员',
  5: '二审员',
  6: '复审员',
};
export const passwordSalt = 'annotation';
// taskstatus为2的时候存在可以标注的图片  为3的时候图片全标注完但是还存在未审核的图片
export const taskStatusMap = { 0: '未开始', 1: '已删除', 2: '标注中', 3: '一审中', 4: '二审中', 5: '已完成' };
export const taskStatusFilterMap = { 1: '未开始', 2: '进行中', 3: '已完成' };
export const imageStatusMap = {
  0: '待标注',
  1: '已删除',
  2: '标注中',
  3: '一审中',
  4: '二审中',
  5: '已完成',
};
export const taskTypeMap = {
  1: 3,
  2: 2,
  3: 0,
  4: 1,
  5: 3,
  6: 2,
  7: 3,
  多边形标注: 3,
  矩形框: 2,
  点标注: 0,
  折线标注: 1,
  文本多边形: 3,
  文本矩形: 2,
};
// 禁止修改标注的任务类型
export const disableAnnoTaskType = 7;
// 待定类别,禁止提交时选择该类型
export const undeterminedClassId = 4000;
// 标注A,B,C分类, key=类别, value=classId集合
export const classificationObj = {
  knife: [3300, 3301, 3302, 3303, 3304, 3305, 3306, 3307, 3308, 3309, 3310, 3311, 3312, 3313, 3318, 3320],
  gf_k_l: [
    3005,
    1456,
    3024,
    3023,
    3017,
    1293,
    1294,
    3006,
    3008,
    3029,
    3025,
    1451,
    1480,
    1483,
    1482,
    1453,
    1455,
    3003,
    3002,
    3279,
    3280,
    3281,
    3282,
    3283,
    3284,
    3285,
    3294,
    3287,
    3288,
    3289,
    3290,
    3291,
    3292,
    3293,
    3295,
    3297,
  ],
};
// classId分类, categoryId区分对应类别
export const categoryMap = {
  '5': 'E类',
  '6': 'F类',
  '7': '标定箱类',
  '8': 'H类',
  '9': 'I',
  '10': 'J',
  '11': 'K',
  '12': 'L',
  '13': 'M',
  '14': 'N',
  '15': 'O',
  '100': '其他',
  '101': 'xman审核',
};
